import { render, staticRenderFns } from "./productLicense.vue?vue&type=template&id=0c2fc3fe&scoped=true"
import script from "./productLicense.vue?vue&type=script&lang=js"
export * from "./productLicense.vue?vue&type=script&lang=js"
import style0 from "./productLicense.vue?vue&type=style&index=0&id=0c2fc3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2fc3fe",
  null
  
)

export default component.exports